import { HALLOWEEN_PROMO_GIFT_COUPON } from '../campaign';

/** Coupon code for new user free shipping (first order) */
export const NEW_USER_FREESHIP_COUPON_CODE = 'newfreeship';

/** @deprecated Use NEW_USER_FREESHIP_COUPON_CODE instead */
export const FREESHIPPING_COUPON_CODE = NEW_USER_FREESHIP_COUPON_CODE;

/** App exclusive coupon codes - applied automatically when logged in on mobile app */
export const APP_EXCLUSIVE_COUPON_CODE = 'app20_skin_seoul';
export const APP_EXCLUSIVE_COUPON_CODE_10 = 'app10_skin_seoul';

/** All app exclusive coupon codes */
export const APP_EXCLUSIVE_COUPON_CODES = [APP_EXCLUSIVE_COUPON_CODE, APP_EXCLUSIVE_COUPON_CODE_10] as const;

/** Display names for app exclusive coupons */
export const APP_EXCLUSIVE_COUPON_DISPLAY_NAME_20 = 'APP20';
export const APP_EXCLUSIVE_COUPON_DISPLAY_NAME_10 = 'APP10';

/** Coupons that should be hidden from user interface but still functional */
export const HIDDEN_COUPONS_AT_DISCOUNT_SECTION = [...APP_EXCLUSIVE_COUPON_CODES];

/** Coupons that cannot be manually applied by users (e.g., app-exclusive coupons) */
export const BLOCKED_MANUAL_APPLY_COUPONS = [...APP_EXCLUSIVE_COUPON_CODES];

/** Error message for blocked coupon codes */
export const BLOCKED_COUPON_ERROR_MESSAGE = 'This coupon cannot be applied.';

export const COUPONS_EXEMPT_FROM_LIMIT = [NEW_USER_FREESHIP_COUPON_CODE, HALLOWEEN_PROMO_GIFT_COUPON];

/**
 * Get display name for a coupon code
 * Returns the original code if no special display name is defined
 */
export const getCouponDisplayName = (couponCode: string): string => {
  if (couponCode === APP_EXCLUSIVE_COUPON_CODE) {
    return APP_EXCLUSIVE_COUPON_DISPLAY_NAME_20;
  }
  if (couponCode === APP_EXCLUSIVE_COUPON_CODE_10) {
    return APP_EXCLUSIVE_COUPON_DISPLAY_NAME_10;
  }
  return couponCode;
};
